import type { Session } from '@openx/types/session.ts';
import type { UseSession } from '@openx/utils/permission/context/PermissionHookTypes.ts';
import { useAuth } from '../../../components/AuthContext/context.ts';

export const useExchangeSession: UseSession = () => {
  const { loading, session } = useAuth();

  return {
    isLoading: loading,
    // Callers must check `isLoading` before relying on `session` — it's only
    // guaranteed once auth finishes, unlike the DSP/pub react-query session.
    session: session?.exchange_session as Session,
  };
};
